import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "pages/landing/Home";
import KnowUs from "pages/landing/KnowUs";
import OurStory from "pages/landing/OurStory";
import Contact from "pages/landing/Contact";
import Faq from "pages/landing/Faq";
import Terms from "pages/landing/Terms";
import Privacy from "pages/landing/Privacy";

import Redirect from "pages/landing/Redirect";

import Signin from "pages/account/Signin";
import Signup from "pages/account/Signup";
import Activate from "pages/account/Activate";
import Forgotpassword from "pages/account/Forgotpassword";
import Resetpassword from "pages/account/Resetpassword";

import PortalHome from "pages/portal/PortalHome";
import PortalShortenUrl from "pages/portal/PortalShortenUrl";
import PortalUrlDetails from "pages/portal/PortalUrlDetails";
import PortalTrackUrl from "pages/portal/PortalTrackUrl";
import PortalAccountSettings from "pages/portal/PortalAccountSettings";
import PortalAnalytics from "pages/portal/PortalAnalytics";
import Signout from "pages/portal/Signout";

export default function UShortRoutes() {

  return (
    <BrowserRouter>
      <Routes>
        
        <Route path="/">
          <Route exact path="/know_us" Component={KnowUs} />
          <Route exact path="/our_story" Component={OurStory} />
          <Route exact path="/faq" Component={Faq} />
          <Route exact path="/terms" Component={Terms} />
          <Route exact path="/privacy" Component={Privacy} />
          <Route exact path="/contact" Component={Contact} />
          <Route exact path="/:id" Component={Redirect} />
          <Route exact path="/" Component={Home} />

          <Route exact path={"signin"} Component={Signin} />
          <Route exact path={"signup"} Component={Signup} />
          <Route exact path={"activate"} Component={Activate} />
          <Route exact path={"forgot_password"} Component={Forgotpassword} />
          <Route exact path={"reset_password"} Component={Resetpassword} />

          <Route exact path={"portal/home"} Component={PortalHome} />
          <Route exact path={"portal/url/create"} Component={PortalShortenUrl} />
          <Route exact path={"portal/url/details"} Component={PortalUrlDetails} />
          <Route exact path={"portal/url/track"} Component={PortalTrackUrl} />
          <Route exact path={"portal/analytics"} Component={PortalAnalytics} />
          <Route exact path={"portal/account/settings"} Component={PortalAccountSettings} />
          <Route exact path={"portal/signout"} Component={Signout} />
          
        </Route>

      </Routes>
    </BrowserRouter>
  );
}